<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <h4>{{ rep.name }}</h4>

            <form-group label="Branches" :required="true">
              <div class="row" v-for="item in branches" :key="item.id">
                <div class="col-6 pt-2">
                  <b-form-checkbox                 
                    v-model="item.selected"
                  >
                    {{ item.name }}
                  </b-form-checkbox>
                </div>
                <div class="col-6">
                  <input
                    :name="item.id"
                    placeholder="Rapid Rep Code"
                    class="form-control mt-2"
                    v-model="item.rep_code"                    
                    v-uppercase
                  />
                </div>
              </div>
         
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import repRepo from "@/api/repos/repRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    rep: {
      user_id: {
        required,
      }
    },
  },

  mounted() {
    this.getData();
  },

  props: ["id"],

  data() {
    return {
      rep: {},
      branches: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await repRepo.createGetData();
        this.branches = data.branches;        
        this.getRep();
      } catch (error) {
        console.log(error);
      }
    },
    async getRep() {
      try {
        this.loading = true;
        let { data } = await repRepo.get(this.id);
        this.rep = data.rep;
        this.branches.forEach(b => {
          this.rep.branches.forEach(r => {
            if(r.branch_id == b.id){
              b.selected = true;
              b.rep_code = r.code;
            }           
          })
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          this.rep.branches = this.branches.filter(b => b.selected)
          await repRepo.update(this.id, this.rep);
          this.$emit("repUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
